

















import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'

@Component({})
export default class Toolbar extends Vue {
    @Prop() btnSave!: HTMLElement;
    @Prop() btnNew!: HTMLElement;
    @Prop() btnDelete!: HTMLElement;
    @Prop() btnPrint!: HTMLElement;
    @Prop() btnLockDocument!: HTMLElement;
    @Prop({default: false}) showLock!: boolean;
    @Prop({default: false}) showPrint!: boolean;

    save() {
        if (this.btnSave) {
            this.btnSave.click();
        }
        this.saveClicked();
    }

    create() {
        if (this.btnNew) {
            this.btnNew.click();
        }
        this.newClicked();
    }

    remove() {
        if (this.btnDelete) {
            this.btnDelete.click();
        }
        this.deleteClicked();
    }

    print() {
        if (this.btnPrint) {
            this.btnPrint.click();
        }
        this.printClicked();
    }

    lockDocument() {
        if (this.btnLockDocument) {
            this.btnLockDocument.click();
        }
        this.lockDocumentClicked();
    }

    @Emit('btnSaveClicked') saveClicked() {
    }

    @Emit('btnNewClicked') newClicked() {
    }

    @Emit('btnDeleteClicked') deleteClicked() {
    }

    @Emit('btnPrintClicked') printClicked() {
    }

    @Emit('btnLockDocument') lockDocumentClicked() {
    }
}
